module.exports = __webpack_public_path__ + "static/media/fileupload.31b8a2da.svg";